import React from "react";
import { useForm } from "react-hook-form";

function BookModal({ title, onClose, returnBook, data }) {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    reset,
  } = useForm({
    defaultValues: {},
  });

  if (!data) {
    return null;
  }

  const saveData = () => {
    const formData = {
      bookLoanId: data?.id,
      returnDate: new Date().toISOString().split("T")[0],
      fineAmount: data?.totalFine,
      updatedBy: localStorage.getItem("userId"),
    };

    returnBook(formData);
  };

  return (
    <>
      <div
        className="modal fade show"
        tabIndex="-1"
        style={{ display: "block" }}
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <form className="" onSubmit={handleSubmit(saveData)}>
              <div className="modal-header">
                <h5 className="mb-0">{title}</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={onClose}
                ></button>
              </div>
              <div className="modal-body">
                <div className="row g-3">
                  <div className="col-md-4">
                    <div className="book-image">
                      <img
                        src={`${process.env.REACT_APP_LIVE_DOMAIN_URL}ExternalImages${data?.imagePath}`}
                        alt="book-preview"
                        className="w-100 mb-2"
                        style={{ height: "170px", objectFit: "cover" }}
                      />
                    </div>
                  </div>
                  <div className="col-md-8">
                    <div className="row g-2 fs-9">
                      <div className="col-md-6">
                        <label className="fw-bold">Book Name</label>
                        <p className="">{data?.bookName}</p>
                      </div>
                      <div className="col-md-6">
                        <label className="fw-bold">Member Name</label>
                        <p className="">{data?.memberName}</p>
                      </div>
                      <div className="col-md-6">
                        <label className="fw-bold">Loan Date</label>
                        <p className="">{data?.loanDate?.split("T")[0]}</p>
                      </div>
                      <div className="col-md-6">
                        <label className="fw-bold">Due Date</label>
                        <p className="">{data?.dueDate?.split("T")[0]}</p>
                      </div>
                      <div className="col-md-6">
                        <label className="fw-bold">Fine per Day</label>
                        <p className="">{data?.finePerDay}</p>
                      </div>
                      <div className="col-md-6">
                        <label className="fw-bold">Total Fine</label>
                        <p className="">{data?.totalFine}</p>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div className="mb-3">
                <div className="row fs-9">
                  <div className="col-md-6">
                    <div>
                      <label className="fw-bold">Student Name:</label>
                      <span className="ms-1">{data.studentName}</span>
                    </div>
                    <div>
                      <label className="fw-bold">Registration No:</label>
                      <span className="ms-1">{data.registrationNo}</span>
                    </div>
                    <div>
                      <label className="fw-bold">Challan No:</label>
                      <span className="ms-1">{data.voucherNo}</span>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div>
                      <label className="fw-bold">Center:</label>
                      <span className="ms-1">{data.centerName}</span>
                    </div>
                    <div>
                      <label className="fw-bold">Class:</label>
                      <span className="ms-1">{data.className}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mb-3">
                <table className="table table-bordered custom-table m-0">
                  <thead>
                    <tr>
                      <th className="fw-bold">Fee Type</th>
                      <th className="fw-bold">Fee Amount</th>
                      <th className="fw-bold">Concession (%)</th>
                      <th className="fw-bold">Net Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.admissionVoucherDetailDto.length > 0 ? (
                      <>
                        {data.admissionVoucherDetailDto.map((fee, index) => (
                          <tr key={index}>
                            <td>{fee.feeTypeName}</td>
                            <td>{fee.amount}</td>
                            <td>{fee.concessionPercentage}</td>
                            <td>{fee.netAmount}</td>
                          </tr>
                        ))}
                        <tr>
                          <td colSpan="3">
                            <strong>Total Amount</strong>
                          </td>
                          <td>
                            <strong>
                              {data.admissionVoucherDetailDto.reduce(
                                (total, fee) => total + fee.netAmount,
                                0
                              )}
                            </strong>
                          </td>
                        </tr>
                      </>
                    ) : null}
                  </tbody>
                </table>
              </div> */}
              </div>
              <div className="modal-footer">
                <div className="d-flex gap-2 justify-content-end">
                  <button
                    type="submit"
                    className="btn btn-sm btn-primary"
                    // onClick={returnBook}
                  >
                    Return
                  </button>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-primary"
                    onClick={onClose}
                  >
                    Close
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
}

export default BookModal;
